<section id="header" class="header mainHead d-mobi-none">
  <div class="heading gold">Edit Passport Profile</div>
</section>
<section id="edit-profile" fxLayout="column" class="flex-md-row basicProfile">
  <div class="profileImage">
    <i class="fa fa-{{profile.userImageUrl ? 'edit' : 'upload'}} btn-upload" (click)="imageInput.click()"></i>
    <img src="{{getProfilePic()}}" alt="" class="image" />
  </div>
  <input style="display: none;"
    type="file"
    accept="image/*"
    #imageInput
    (change)="updateProfileImageFile($event)">
  <section id="header" class="header mainHead no-desktop">
    <div class="heading gold">Edit Passport Profile</div>
  </section>
  <div class="content px-md-5 pt-md-0 pt-4">
    <form (ngSubmit)="handleSaveProfile()" #f="ngForm">
      <div fxLayout="column">
        <div
          fxLayout="row"
          fxLayoutAlign="space-between"
          class="heading-section"
        >
          <div fxLayout="column">
            <span class="gold">First Name</span>
            <input
              class="edit-input"
              placeholder="Add name"
              [(ngModel)]="firstName"
              name="firstName"
            />
          </div>
          <div fxLayout="column">
            <span class="gold">Last Name</span>
            <input
              class="edit-input"
              placeholder="Add name"
              [(ngModel)]="lastName"
              name="lastName"
            />
          </div>
          <div fxLayout="column">
            <button class="btn-cancel" type="button" (click)="handleCancel()">Cancel</button>
            <button class="profile-button" type="submit">Save Profile</button>
          </div>
        </div>
        <div fxLayout="column">
          <span class="gold">Personal Bio</span>
          <textarea
            class="edit-area"
            rows="7"
            placeholder="Add Bio"
            name="bio"
            [(ngModel)]="bio"
          ></textarea>
        </div>
      </div>
    </form>
  </div>
</section>
